const document = typeof window !== "undefined" && typeof window.document !== "undefined" ? window.document : {};
const keyboardAllowed = typeof Element !== "undefined" && "ALLOW_KEYBOARD_INPUT" in Element;

const fnMap = [
  [
    "requestFullscreen",
    "exitFullscreen",
    "fullscreenElement",
    "fullscreenEnabled",
    "fullscreenchange",
    "fullscreenerror",
  ],
  // New WebKit
  [
    "webkitRequestFullscreen",
    "webkitExitFullscreen",
    "webkitFullscreenElement",
    "webkitFullscreenEnabled",
    "webkitfullscreenchange",
    "webkitfullscreenerror",
  ],
  // Old WebKit (Safari 5.1)
  [
    "webkitRequestFullScreen",
    "webkitCancelFullScreen",
    "webkitCurrentFullScreenElement",
    "webkitCancelFullScreen",
    "webkitfullscreenchange",
    "webkitfullscreenerror",
  ],
  [
    "mozRequestFullScreen",
    "mozCancelFullScreen",
    "mozFullScreenElement",
    "mozFullScreenEnabled",
    "mozfullscreenchange",
    "mozfullscreenerror",
  ],
  [
    "msRequestFullscreen",
    "msExitFullscreen",
    "msFullscreenElement",
    "msFullscreenEnabled",
    "MSFullscreenChange",
    "MSFullscreenError",
  ],
];

let fn;
let i = 0;
const l = fnMap.length;
const ret = {};

for (; i < l; i++) {
  const val = fnMap[i];

  if (val && val[1] in document) {
    for (i = 0; i < val.length; i++) ret[fnMap[0][i]] = val[i];

    fn = ret;
  }
}

const eventNameMap = {
  change: fn.fullscreenchange,
  error: fn.fullscreenerror,
};

/**
 *
 */
class ScreenFull {
  /**
   *
   */
  constructor() {
    if (!fn) return false;
  }

  /**
   *
   * @return {Boolean}
   */
  get isFullScreen() {
    return Boolean(document[fn.fullscreenElement]);
  }

  /**
   *
   * @return {*}
   */
  get element() {
    return document[fn.fullscreenElement];
  }

  /**
   *
   * @return {Boolean}
   */
  get enabled() {
    return Boolean(document[fn.fullscreenEnabled]);
  }

  /**
   *
   * @param {*} elem
   * @memberof ScreenFull
   */
  request = (elem = document.documentElement) => {
    const request = fn.requestFullscreen;

    elem = elem || document.documentElement;

    // Work around Safari 5.1 bug: reports support for
    // keyboard in fullscreen even though it doesn"t.
    // Browser sniffing, since the alternative with
    // setTimeout is even worse.
    if (/ Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent)) {
      elem[request]();
    } else {
      elem[request](keyboardAllowed && Element.ALLOW_KEYBOARD_INPUT);
    }
  }

  /**
   *
   * @memberof ScreenFull
   */
  exit = () => {
    document[fn.exitFullscreen]();
  }

  /**
   *
   * @memberof ScreenFull
   * @param {*} elem
   * @return {void}
   */
  toggle = (elem) => this.isFullScreen ? this.exit() : this.request(elem);

  /**
   *
   * @memberof ScreenFull
   * @param {Function} callback
   * @return {void}
   */
  onChange = (callback) => this.on("change", callback);

  /**
   *
   * @memberof ScreenFull
   * @param {Function} callback
   * @return {void}
   */
  onError = (callback) => this.on("error", callback);

  /**
   *
   * @memberof ScreenFull
   * @param {String} event
   * @param {Function} callback
   */
  on = (event, callback) => {
    const eventName = eventNameMap[event];

    if (eventName) document.addEventListener(eventName, callback, false);
  }

  /**
   *
   * @memberof ScreenFull
   * @param {String} event
   * @param {Function} callback
   */
  off = (event, callback) => {
    const eventName = eventNameMap[event];

    if (eventName) document.removeEventListener(eventName, callback, false);
  }
}

export default new ScreenFull();
